import { Pipe, PipeTransform } from '@angular/core'
import { DecimalPipe } from '@angular/common'

@Pipe({
  name: 'cycRpm',
})
export class RpmPipe implements PipeTransform {
  constructor(private decimal: DecimalPipe) {}

  transform(value: unknown, abs = false, dp = 1): unknown {
    if (typeof value === 'number') {
      const val = abs ? Math.abs(value) : value
      return this.decimal.transform(val, `1.${dp}-${dp}`)
    }
    return null
  }
}
